import { useCallback } from 'react';
import { useDataApi } from '../useDataApi/useDataApi';
import { ResponseData, RequestData } from '../useDataApi/requestData';
import { Features } from '../../context/usageLoggerContext/featureConstants';
import { useUsageLogger } from '../../context/usageLoggerContext/usageLoggerContext';
import { useBuddiContext } from '../../context/buddiContext/buddiContext';
import { useUserContext } from '../../context/userContext/userContext';

export const useDeleteJobSchedule = (
  projectId: string,
  iModelId: string
): [null, boolean, any, (jobId: string) => Promise<ResponseData<null>>] => {
  const { user } = useUserContext();
  const { buddiUrls } = useBuddiContext();

  const { logFeature } = useUsageLogger();

  const useDataSettings = { initialData: null, initialIsLoading: false };
  const [data, isLoading, error, fetchData] = useDataApi(useDataSettings);

  const deleteJobSchedule = useCallback(
    async (jobDefinitionId: string) => {
      const parameters = {
        jobdefId: jobDefinitionId,
        userId: user!.profile.sub,
        iModelId: iModelId,
        contextId: projectId,
      };
      const parameterString = new URLSearchParams(parameters).toString();
      const url = `${buddiUrls.iModelBridgeSchedulerUrl}/api/JobSchedule?${parameterString}`;

      const requestData: RequestData<any> = {
        url: url,
        method: 'DELETE',
      };

      logFeature(Features.DeleteJobSchedule);
      return fetchData(requestData);
    },
    [user, iModelId, projectId, buddiUrls, logFeature, fetchData]
  );

  return [data, isLoading, error, deleteJobSchedule];
};
